import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware, ConnectedRouter as RawConnectedRouter } from 'connected-react-router';
import rootReducer from './reducers';
import sagas, { createSagaMiddleware } from './sagas';
import { all } from 'redux-saga/effects';
import { sentryUserMiddleware, sentryReduxStateMiddleware } from './utils/redux/middlewares';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  trace: true
}) : compose;
const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware(Sentry);

// Compose Sentry middlewares
const sentryMiddlewares = [sentryUserMiddleware, sentryReduxStateMiddleware].map(middleware => middleware(Sentry));
const middlewares = [sagaMiddleware, routerMiddleware(history), ...sentryMiddlewares];
const store = createStore(combineReducers({
  ...rootReducer,
  router: connectRouter(history)
}), composeEnhancers(applyMiddleware(...middlewares)));
function* rootSaga() {
  yield all(sagas.flat());
}
sagaMiddleware.run(rootSaga);
const ReduxProvider = props => /*#__PURE__*/React.createElement(Provider, {
  store: store
}, props.children);
ReduxProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default ReduxProvider;
export const ConnectedRouter = props => /*#__PURE__*/React.createElement(RawConnectedRouter, {
  history: history
}, props.children);
ConnectedRouter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};